export default __webpack_public_path__ + "static/right-banner-8615dc4bc05db06517cdc6da45951325.png";